import UseTemplateModal from './UseTemplateModal';

export default UseTemplateModal;
